/**
 * The org selector for the current invocation.
 *
 * Set once from the program's `preAction` hook so every command inherits it
 * without threading it through. Threading it per call site works only while
 * every author remembers: one command that omitted it would silently resolve
 * against the repo's org instead of the one the caller asked for, and for a
 * destructive command that is the wrong base in the wrong org. The value is the
 * input to a grant-validated attestation, so it must not be
 * convention-enforced.
 *
 * Its own module rather than a field on the client, because it is invocation
 * state and not client state — and because a test that mocks the client should
 * not have to stub a setter to make the parser work.
 */

let override: string | undefined;

/** Record the invocation's `--org`. Called by the program's hook, not by commands. */
export function setDataOrgOverride(orgId: string | undefined): void {
  override = orgId;
}

/** The recorded `--org`, or undefined when the flag was not passed. */
export function getDataOrgOverride(): string | undefined {
  return override;
}
